import React from 'react';
import { Button as ShadcnButton, ButtonProps as ShadcnButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ActionButtonProps extends Omit<ShadcnButtonProps, 'variant'> {
    variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
}

export const ActionButton = React.forwardRef<HTMLButtonElement, ActionButtonProps>(({ className, variant = 'default', ...props }, ref) => {
    return (
        <ShadcnButton
            ref={ref}
            variant={variant}
            className={cn(
                // Glue ActionButton styling
                'min-w-[120px] rounded-lg font-bold border-2 transition-all duration-200',
                'border-primary bg-background text-foreground',
                // Rainbow hover effect using CSS animation
                'hover:animate-pulse hover:bg-gradient-to-r hover:from-red-500 hover:via-yellow-500 hover:via-green-500 hover:via-blue-500 hover:to-purple-500',
                'hover:bg-[length:400%_400%] hover:animation-gradient-shift',
                // Disabled state
                'disabled:hover:bg-muted disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            {...props}
        />
    );
});

ActionButton.displayName = 'ActionButton';
